import { render, staticRenderFns } from "./_uptimeBot.vue?vue&type=template&id=09240fcb"
import script from "./_uptimeBot.vue?vue&type=script&lang=js"
export * from "./_uptimeBot.vue?vue&type=script&lang=js"
import style0 from "./_uptimeBot.vue?vue&type=style&index=0&id=09240fcb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports